import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootReducerState } from '../../redux/Reducers';
import { FullServiceInstallationReportList } from '../../types/telcobill/full-service-installation-report.type';
import { rejectWithApiError } from '../../utils/api';
import { additionalQueryParams } from '../../utils/utilities';

export type GetFullServiceInstallationReportRequest = {
  installationStartDate?: string;
  installationEndDate?: string;
  customerNames?: string[];
  locations?: string[];
  shippedBys?: string;
  serviceOrganizationIds?: string;
  q?: string;
  order?: string;
  page?: number;
  limit?: number;
};

export const getFullServiceInstallationReport = createAsyncThunk<
  FullServiceInstallationReportList,
  { params: GetFullServiceInstallationReportRequest },
  { state: RootReducerState }
>('fullServiceInstallationReport/getReport', async ({ params }, thunkAPI) => {
  try {
    const additionalParams = additionalQueryParams(
      thunkAPI.getState().sharedReducer.selectedCompany,
      null,
      thunkAPI.getState().sharedReducer.includeSuborgs
    );

    const response = await axios.get<FullServiceInstallationReportList>(
      `${process.env.REACT_APP_API_URL}/full-service-installation-report`,
      { params: { ...params, ...additionalParams } }
    );

    return response.data;
  } catch (error) {
    return rejectWithApiError({
      thunkAPI,
      error,
      fallback: 'Error while fetching Full Service Installation Report.',
    });
  }
});
